import { Dispatch, SetStateAction } from 'react';
import Image from 'next/future/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Modal from '../Modal';
import { useBuybackContext } from '@/lib/buyback/BuybackContext';
import infoIcon from '@/public/icons/buyback/thank-you/info.svg';
import QuoteSummaryContent from './QuoteSummaryContent';

export default function QuoteSummary({
  showModal,
  setShowModal,
}: Readonly<{
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}>) {
  const { summaryQuote } = useBuybackContext();
  const router = useRouter();
  const handle = router.query.handle as string;

  if (summaryQuote == null) return null;

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      title="Quote Details"
    >
      <div className="flex-1 overflow-auto">
        <div className="bg-gray-200 p-5">
          <div className="flex h-[150px] w-full items-center justify-center">
            <Image
              src={summaryQuote.image}
              height={200}
              width={200}
              className="h-full w-auto object-contain"
              alt="Device"
            />
          </div>
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 rounded-lg bg-[#ECFCF5] p-3 text-[#2C4A4B]">
            <div className="h-6 w-6 shrink-0">
              <Image
                alt="Info"
                src={infoIcon}
                className="h-full w-full"
                height={50}
                width={50}
              />
            </div>
            <span>
              Make sure your quote is accurate. It is the only way we can
              provide you with an accurate price estimation
            </span>
          </div>
        </div>
        <div className="px-5 pb-5">
          <QuoteSummaryContent />
          <Link href={`/buyback/${handle}/device`}>
            <button
              type="button"
              className="mt-5 flex h-10 w-full items-center justify-center rounded-lg bg-gray-700 font-bold text-white"
            >
              Restart Quote
            </button>
          </Link>
        </div>
      </div>
    </Modal>
  );
}
